import { useQuery } from '@apollo/react-hooks';
import { OrgSettings } from '@opsbase/lib-org/OrgSettings';
import Palette from '@opsbase/lib-palette';
import { getStoredValue, setStoredValue } from '@opsbase/lib-storage';
import { useSelfActions } from '@opsbase/react-ctrl-self/useSelfActions';
import useCss from '@opsbase/web-css';
import Pane from '@opsbase/web-layout/Pane';
import useParams from '@opsbase/web-nav/useParams';
import gql from 'graphql-tag';
import React, { useEffect, useMemo, useRef } from 'react';
import ReportCoverPage from '../../ReportCoverPage';
import DetailsReportConversation from '../DetailsReportConversation';
import { getDetailsReportDefinition } from '../DetailsReportDefinition';
import DetailsIssueReportContext from './DetailsIssueReportContext';
import DetailsIssueReportSummary from './DetailsIssueReportSummary';
const makeMyClasses = pdf => ({
    root: {
        margin: pdf ? undefined : 'auto',
        marginTop: pdf ? undefined : 10,
        maxWidth: pdf ? undefined : 700,
        backgroundColor: 'white',
        color: Palette.BlackCoral.main,
        fontFamily: 'Gilroy',
    },
    heading1: {
        breakBefore: pdf ? 'page' : undefined,
        fontSize: 12,
        fontWeight: 'bolder',
        textTransform: 'uppercase',
        lineHeight: '24px',
        marginTop: 16,
        marginBottom: 4,
        color: Palette.Black.main,
        '& p': {
            fontSize: 12,
        },
    },
});
const query = gql `
	query GetIssueDetailsReportData($id: String!, $organisationId: String!, $stamp: String!) {
		issueDetailsReportData(id: $id, organisationId: $organisationId, stamp: $stamp) {
			__typename
			id
			title
			flag
			type
			status
			occurrenceDate
			deadlineDate
			closedDate
			updatedDate
			conversation {
				__typename
				id
				title
				messages
				participants {
					id
					title
					hasProfileImage
					profileImageUrl
				}
			}
			organisation {
				__typename
				id
				title
				settings
			}
			activity
			place {
				__typename
				id
				title
				timezone
			}
			createdBy {
				__typename
				id
				title
				profileImageUrl
			}
			closedBy {
				__typename
				id
				title
				profileImageUrl
			}
			organisation {
				__typename
				id
				title
				settings
			}
			assignedToSPTType
			assignedToStaff {
				__typename
				id
				title
				profileImageUrl
			}
			assignedToPosition {
				__typename
				id
				title
			}
			assignedToTeam {
				__typename
				id
				title
			}
			commentors {
				__typename
				id
				title
			}
			causes
			correctiveActions
			preventativeActions
			asset {
				id
				title
			}
			associatedIntegrationId
		}
	}
`;
export function DetailsIssueReportPage() {
    var _a, _b, _c;
    const { key } = useParams();
    const { updateSettings } = useSelfActions();
    const { id, organisationId, stamp, token } = getDetailsReportDefinition(key);
    if (getStoredValue('accessToken') !== token)
        setStoredValue('accessToken', token);
    const { loading, data } = useQuery(query, {
        variables: {
            id,
            organisationId,
            stamp,
        },
    });
    const def = getDetailsReportDefinition(key);
    const myCss = useCss(makeMyClasses, [def.pdf]);
    const issue = data === null || data === void 0 ? void 0 : data.issueDetailsReportData;
    const ctx = useMemo(() => ({
        issue,
        def,
    }), [issue, def]);
    const settingsUpdated = useRef(false);
    useEffect(() => {
        var _a;
        if (!issue || settingsUpdated.current)
            return;
        updateSettings(new OrgSettings((_a = issue === null || issue === void 0 ? void 0 : issue.organisation) === null || _a === void 0 ? void 0 : _a.settings));
        settingsUpdated.current = true;
    }, [updateSettings, issue]);
    if (!issue || loading)
        return null;
    return (React.createElement(DetailsIssueReportContext.Provider, { value: ctx },
        React.createElement(Pane, { classes: { root: myCss.root }, padding: !def.pdf },
            React.createElement(ReportCoverPage, { title: issue.title, subTitle: issue.organisation.title, logoId: (_a = issue.organisation.settings) === null || _a === void 0 ? void 0 : _a.logoId, titleColor: (_b = issue.organisation.settings) === null || _b === void 0 ? void 0 : _b.titleColor, pdf: def.pdf }),
            React.createElement(DetailsIssueReportSummary, null),
            React.createElement("div", { className: myCss.heading1 }, "Conversation"),
            React.createElement(DetailsReportConversation, { conversation: issue.conversation, activity: issue.activity, timezone: (_c = issue.place) === null || _c === void 0 ? void 0 : _c.timezone }))));
}
export default DetailsIssueReportPage;
